$(document).ready(function(){
  two_column_hours();
});

$(window).on('resize',function() {
	two_column_hours_init();
});

function two_column_hours_init() {
	$('.two-column-hours--button').each(function() {
		if ( $(this).css('display') == 'none' ) {
			$(this).parent().attr('aria-expanded', '');

			$(this).parents('.block__inner')
				.find('.active').removeClass('active')
				.find('.expanded').removeClass('expanded')
				.find('.toggable').show();
		}
		else {
			$(this).parent().attr('aria-expanded', false);
			$(this).parents('.block__inner')
				.find('.active').removeClass('active expanded')
				.next('.toggable').hide();	
		}	
	});
}

  function two_column_hours() {
  	two_column_hours_init();

    $('.two-column-hours--button').click(function() {
      var ariaLabel = $(this).attr('aria-label');

      $(this).toggleClass('active');
      $(this).toggleClass('expanded');
      $(this).next('.toggable').slideToggle();
      $('.icon', $(this)).toggleClass('active');

      // if it's open
      if ( $(this).hasClass('expanded') ) {
        $(this).attr('aria-label', ariaLabel.replace('Expand and show','Collapse and hide'));
        $(this).parent().attr('aria-expanded', true);
      }
      // if it's closed
      else {
        $(this).attr('aria-label', ariaLabel.replace('Collapse and hide','Expand and show'));
        $(this).parent().attr('aria-expanded', false);
      }
    });
  }